import { h } from 'preact';
import PureComponent from './PureComponent';
import getJSON from '../utils/get-json';
import { select, geoAlbersUsa, geoPath, } from "d3";

import STATE_BOUNDARY from 'Assets/geography/texas_boundary.geo.json';

const P = {
  padding: 3,
  radius: 2
}

class DistrictMapMini extends PureComponent {
  constructor() {
    super();

    this.state = {
      width: null,
      mapWidth: 55,
      projection: null
    };
  }

  drawMap() {
    const { geometry } = this.props;
    const office = geometry.properties.stats.office;
    const district = geometry.properties.district;
    const id = `district-map__mini__${office}__${district}`

    const districtGeo = geometry.geometry_simple;
    const areaSize = geometry.properties.meta.area;
    const center = geometry.geometry.centroid;

    const body = select('.district-map');
    const width = body.node().offsetWidth;
    // const mapWidth = Math.max(width / 6, 45);
    const mapWidth = 50;

    const projection = geoAlbersUsa()
      .fitExtent([[P.padding, P.padding], [mapWidth - P.padding * 2, mapWidth - P.padding * 2]], STATE_BOUNDARY);
    const [x, y] = projection(center);

    const canvas = select(`#${id}`).select("canvas");
    canvas.attr("width", mapWidth).attr("height", mapWidth)

    const ctx = canvas.node().getContext('2d');

    const pathGenerator = geoPath(projection, ctx);

    ctx.beginPath();
    pathGenerator(STATE_BOUNDARY);
    ctx.fillStyle = "#cccccc";
    ctx.fill();

    if(areaSize > 15000000000) {
      ctx.beginPath();
      pathGenerator(districtGeo);
      ctx.fillStyle = "#333333";
      ctx.fill();
    } else {
      ctx.beginPath();
      ctx.arc(x, y, P.radius, 0, 2 * Math.PI)
      ctx.fillStyle = "#333333";
      ctx.fill();
    }
  }

  componentDidMount() {
    this.drawMap();
  }

  componentDidUpdate(prevProps) {

  }

  render() {
    const { geometry } = this.props;
    const office = geometry.properties.stats.office;
    const district = geometry.properties.district;
    const id = `district-map__mini__${office}__${district}`

    return (
      <div id={id} class="district-map__mini">
        <canvas></canvas>
        <h5>Area<br/>shown</h5>
      </div>
    );
  }
}

export default DistrictMapMini;